import { useEffect } from "react";
import {
  resolveLocale,
  setLocale,
  selectLocaleMode,
  i18next,
  useAppDispatch,
  useAppSelector,
} from "@reciperoll/core";

// Resolves the effective UI locale from the user's language choice (localeMode)
// and keeps i18next + the persisted `locale` in sync. "system" follows the
// browser locale; any other value pins that language.
export function LocaleBootstrap() {
  const dispatch = useAppDispatch();
  const localeMode = useAppSelector(selectLocaleMode);

  useEffect(() => {
    const effective =
      localeMode === "system" ? resolveLocale(navigator.language) : localeMode;
    dispatch(setLocale(effective));
    i18next.changeLanguage(effective);
  }, [dispatch, localeMode]);

  return null;
}
